
import ComponentHelper from './components/00_utilities/helpers/ComponentHelper';
const componentHelper = new ComponentHelper();

if (__devMode__) {
    __webpack_public_path__ = 'http://localhost:9191/wp-content/themes/lbb2/';
}

componentHelper.initializePage();



function removeAfterReload() {
    document.querySelector('body').classList.remove('body-remove-on-load');
}

window.$ = jQuery;

$(window).on('load', () => {
    setTimeout(removeAfterReload, 1000);
});


/**
 * Check for hot module replacement and use it if possible
 */
if (module.hot) {
    module.hot.accept();
}
